import Style from './PreDelivering.module.css';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText,
} from 'reactstrap';

import Paginations from '../../../components/Paginations';
import PaginationSummaries from '../../../components/Paginations/PaginationSummaries';
import { CardHeaderWithToolbars, Title } from '../../../components/Card/CardHeaderWithToolbars';
import Toolbars from './Filters/Toolbars';
import FiltersPanel from '../Filters';
import FilterContainer from '../../../components/Container/FilterContainer/FilterContainer';
import { Tbl, TblHead, TblBody } from '../../../components/Tbl';
// import { ModalDeliver } from './Modals';
import ModalDeliver from './ModalSubmitCourier';
import ModalAddress from './ModalAddress';
import { ModalInfoCreditCard } from '../../../components/Modals';
import { generateNumber } from '../../../utils';
import { DEFAULT_SORT_BY, DEFAULT_PER_PAGE } from '../../../constants/settings';
import { doDeliverSneakerConsignment } from '../../../actions/consignmentAction';
import { doFetchProvinces, doFetchCities } from '../../../actions/userShippingAction';
import { saveUserAddress, updateUserAddress, getUserShippingList } from '../../../actions/userAction';
import { getCountryList } from "../../../actions/countryAction";

import { getConsignmentList } from '../../../actions/consignmentAction';
import privateView from '../../../components/hocs/privateView';
import RowItem from './RowItem';
import RowHeader from './RowHeader';
import Analytics from "../../../services/Analytics";


const defaultParams = {
  type: 'verification_failed',
  sort_by: DEFAULT_SORT_BY,
  per_page: DEFAULT_PER_PAGE
}

class PreDelivering extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _filterOpen: false,
      _params: {
        ...defaultParams
      },
      _modalAddress: false,
      _formAddressSelected: null,
      _updateAddressProcess: false,
      _selectedRowAddress: null,
      user_id: 0,
      shipping_id: 0,

      _autodisburse: true,
      _selectedRow: null,
      _modalDeliver: false,
      _formDeliverSelected: null,
      _deliverProcess: false,
      _modalCreditCard: false,
      _invoiceNumber: null,
    }
    this._handleApplyFilter = this._handleApplyFilter.bind(this);
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleGoto = this._handleGoto.bind(this);
    this._refreshList = this._refreshList.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._onCloseDeliverModal = this._onCloseDeliverModal.bind(this);
    this._onCloseAddressModal = this._onCloseAddressModal.bind(this);
    this._handleCategoryChanged = this._handleCategoryChanged.bind(this);
    this._handleToggleModalCreditCard = this._handleToggleModalCreditCard.bind(this);
  }

  componentDidMount() {
    const { email } = this.props.injectedProps;
    this._getList(this.state._params);
    Analytics.recordPageView('predelivering_consignment', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.consignment.isSubmit !== this.props.consignment.isSubmit) {
      if (!this.props.consignment.isSubmit && !this.props.consignment.error) {
        this._getList(this.state._params);
        this.setState({
          _deliverProcess: !this.state._deliverProcess,
          _modalDeliver: false,
          _selectedRow: null
        });
      }
    }

    if (prevProps.user.isSubmit && prevProps.user.isSubmit !== this.props.user.isSubmit) {
      if (this.props.user.status_code === 200) {
        this.setState({
          _updateAddressProcess: false,
          _modalAddress: !this.state._modalAddress,
          _selectedRowAddress: null,
        })
        this.props.getUserAddress(this.state.user_id)
      } else {
        this.setState({
          _updateAddressProcess: false,
          _selectedRowAddress: null,
        })
      }
    }

    if (prevProps.user.detail.user_shipping.isFetch && prevProps.user.detail.user_shipping.isFetch !== this.props.user.detail.user_shipping.isFetch) {
      if (this.props.user.detail.user_shipping.status_code === 200) {
        const listAddress = this.props.user?.detail?.user_shipping?.list?.data;
        const addressSelected = listAddress.find((a) => a.id === this.state.shipping_id);
        this.setState({
          _formDeliverSelected: {
            ...this.state._formDeliverSelected,
            shipping: addressSelected
          }
        })
      }
    }
  }

  _getList(rawParams = {}) {
    let p = { ...rawParams }
    if (p.voucher) {
      const { voucher, ...other } = p;
      if (Number(voucher.id)) {
        p = { ...other, voucher_id: voucher.id }
      }
      else {
        p = { ...other, voucher_code: voucher.code }
      }
    }
    if (p.seller && p.seller.id) {
      const { seller, ...other } = p;
      p = { ...other, seller_id: seller.id }
    }
    const params = Object.keys(p)
      .filter(key => p[key] != '')
      .reduce((obj, current) => ({ ...obj, [current]: p[current] }), {});
    this.props.getList({ params });
  }

  _refreshList() {
    // Exclude page...
    const _params = { ...this.state._params, page: 1 };
    this.setState({
      _params: { ..._params }
    }, () => this._getList(this.state._params));
  }

  _toggleFilterPanel() {
    this.setState({ _filterOpen: !this.state._filterOpen })
  }

  _handleToggleFilterPanel(e) {
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _handleRefresh(e) {
    e.preventDefault();
    this._refreshList();
  }

  _handleResetFilter(e) {
    e.preventDefault();
    const newState = this.state._filterOpen ? { _filterOpen: !this.state._filterOpen } : {};
    this.setState({
      ...newState,
      _params: { ...defaultParams },
      _isResetFilter: true
    }, () => this._getList(this.state._params));
  }

  _handleApplyFilter(payloadFilter) {
    this.setState({
      _params: {
        ...this.state._params,
        ...payloadFilter,
        page: 1
      }
    }, () => this._getList(this.state._params));
  }

  _handleGoto(page) {
    const _params = this.state._params;
    _params.page = page;
    this.setState({ _params }, () => this._getList(this.state._params));
  }

  _onOpenCreditCardModal(item) {
    this.setState({ _invoiceNumber: item.invoice_number }, () => this._handleToggleModalCreditCard());
  }

  _handleToggleModalCreditCard() {
    this.setState({ _modalCreditCard: !this.state._modalCreditCard });
  }

  _onRenderRowItem() {
    if (this.props.consignment.list.status_code === 200 && this.props.consignment.list.data.length > 0) {
      const { current_page, per_page } = this.props.consignment.list;
      return this.props.consignment.list.data.map((item, index) => {
        const rowId = generateNumber(per_page, current_page, index);
        return (
          <RowItem
            key={rowId}
            rowId={rowId}
            id={item.id}
            quantity={item.user_sell.quantity}
            buyerEmail={item.buyer_email}
            sellerEmail={item.seller_email}
            consignmentId={item.user_sell.consignment_id}
            orderDate={item.created_at}
            updatedAt={item.updated_at}
            approvedAt={item.approved_at}
            rack={item.user_sell.rack}
            size={item.user_sell.size.US}
            displayName={item.user_sell.product_variant?.display_name}
            SKU={item.user_sell.product_variant?.SKU}
            colour={item.user_sell.product_variant?.colour}
            stockStatus={item.user_sell.stock_status}
            category={item.product_variant.product.category.name}
            status={item.status}
            totalAmount={item.user_sell.asking_price}
            sneakersCondition={item.user_sell.sneakers_condition}
            preVerified={item.user_sell.pre_verified}
            preOrder={item.user_sell.pre_order}
            autoCancel={item.auto_cancelled_at}

            invoiceNumber={item.invoice_number}
            isSelected={this.state._selectedRow === item.id}
            hijacked={item.hijacked}
            autoDisburse={item.autodisburse}
            onOpenDeliverModal={() => this._onOpenDeliverModal(item)}
            onOpenCreditCard={() => this._onOpenCreditCardModal(item)}
            marked={item.marked}
            notes={item.sale_notes}
            loginId={this.props.injectedProps.id}
            legitCheckLogs={item.legit_check_logs}
            markedAt={item.open_marked_at}
            markedBy={item.open_marked_by}
            closeMarkedAt={item.close_marked_at}
            unreadNoteCount={item.unread_notes_count}
            compensation={item.compensation_amount}
            voucherCode={item.voucher_code ? item.voucher_code : item.voucherable ? item.voucherable.code : item.voucherable_id}
          />
        )
      })
    }
    return null;
  }

  _onDelivery(id, data) {
    const { email } = this.props;
    const { _formDeliverSelected } = this.state;

    this.setState({ _deliverProcess: true }, () => {
      this.props.deliverSneaker(id, data);
      Analytics.recordDeliverOrder(
        email,
        data.notes,
        _formDeliverSelected.invoice_number,
        _formDeliverSelected.buyer_email,
        _formDeliverSelected.price
      );
    })
  }

  _onUpdateAddress(userId, shippingId, data) {
    this.setState({
      _updateAddressProcess: true,
      shipping_id: shippingId,
    })

    if (data.id) {
      this.props.updateAddress(this.state.user_id, shippingId, data)
    } else {
      this.props.saveAddress(this.state.user_id, data)
    }
  }

  _onOpenDeliverModal(item) {
    this.setState({
      _formDeliverSelected: item,
      _selectedRow: item.id,
      user_id: item.user_id
    }, () => this._toggle('_modalDeliver'));

    if (item.shipping && Object.keys(item.shipping).length === 0 || item.shipping === null) {
      this.props.getUserAddress(item.user_id);
    }
  }

  _onCloseDeliverModal() {
    this.setState({
      _formDeliverSelected: null,
      _selectedRow: null
    }, () =>
      this._toggle('_modalDeliver'),
      this._refreshList());
  }

  _onOpenAddressModal = async (data) => {
    if (!data) {
      await this.setState({
        _formAddressSelected: null,
        _selectedRowAddress: null,
      }, () => this._toggle('_modalAddress'));
    } else {
      await this.setState({
        _formAddressSelected: data,
        _selectedRowAddress: data.id,
      }, () => this._toggle('_modalAddress'));
    }
  }

  _onCloseAddressModal() {
    this.setState({
      _formAddressSelected: null,
      _selectedRowAddress: null
    }, () => this._toggle('_modalAddress'));
  }

  _toggle(_modalState) {
    const lastState = { ...this.state };
    lastState[_modalState] = !lastState[_modalState];
    this.setState(lastState);
  }

  _onRenderPagination() {
    const { status_code, data } = this.props.consignment.list;
    const hasData = (status_code === 200 && data.length) || null;
    return hasData && (
      <Paginations
        size="sm"
        lastPage={this.props.consignment.list.last_page}
        perPage={this.props.consignment.list.per_page}
        total={this.props.consignment.list.total}
        maxPage={8}
        path={this.props.consignment.list.path}
        currentPage={this.props.consignment.list.current_page}
        prevPageUrl={this.props.consignment.list.prev_page_url}
        nextPageUrl={this.props.consignment.list.next_page_url}
        handleGotoCallback={this._handleGoto}
      />
    );
  }

  async _handleCategoryChanged(category) {
    await this.setState({
      _params: {
        ...this.state._params,
        category: category === '' ? category : category.value,
        page: 1,
      },
    });
    const { _params } = this.state;
    this._getList(_params);
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <ModalDeliver
            isOpen={this.state._modalDeliver}
            onCancel={this._onCloseDeliverModal}
            onSubmit={(id, form) => this._onDelivery(id, form)}
            consignment={this.state._formDeliverSelected}
            error={this.props.consignment.error}
            isSubmit={this.state._deliverProcess}
            onOpenAddressModal={(data) => this._onOpenAddressModal(data)}
            dataShipping={this.props.dataShipping}
          />
          <ModalAddress
            isOpen={this.state._modalAddress}
            onCancel={this._onCloseAddressModal}
            data={this.state._formAddressSelected}
            getCountries={this.props.getCountries}
            dataCountries={this.props.country}
            getProvinces={this.props.getProvinces}
            getCities={this.props.getCities}
            dataProvinces={this.props.dataProvinces}
            dataCities={this.props.dataCities}
            onSubmit={(userId, shippingId, data) => this._onUpdateAddress(userId, shippingId, data)}
            isSubmit={this.state._updateAddressProcess}
          />
          <ModalInfoCreditCard
            isOpen={this.state._modalCreditCard}
            toggle={this._handleToggleModalCreditCard}
            invoiceNumber={this.state._invoiceNumber}
          />
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Seller Take Out Pre-Delivering List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FiltersPanel
                  {...this.state._params}
                  onApplyFilter={this._handleApplyFilter}
                  isReset={this.state._isResetFilter}
                  onResetFilterCallback={() => this.setState({ _isResetFilter: false, _filterOpen: false })}
                  isOpen={this.state._filterOpen}
                />
              </FilterContainer>
              <CardBody>
                <CardText>
                  In this section we have to set ready to deliver the order after legit check failed.
                </CardText>
                <div className="table-responsive">
                  <PaginationSummaries
                    from={this.props.consignment.list.from}
                    to={this.props.consignment.list.to}
                    total={this.props.consignment.list.total}
                  />
                  <Tbl>
                    <TblHead>
                      <RowHeader
                        categoryName={this.state._params.category}
                        categoryValue={this.state._params.category}
                        onCategoryChanged={this._handleCategoryChanged}
                      />
                    </TblHead>
                    <TblBody
                      isLoad={this.props.consignment.isFetch}
                      hasRow={this.props.consignment.list.status_code === 200 && this.props.consignment.list.data.length > 0}
                      columnCount={7}
                    >
                      {this._onRenderRowItem()}
                    </TblBody>
                  </Tbl>
                </div>
                {this._onRenderPagination()}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = ({ consignment, sale, auth: { id: authId, isFetch, isLogged, roles, id, email }, userShipping, country, user }) => {
  return {
    consignment,
    sale,
    email,
    guardData: { isFetch, isLogged, roles, id: authId, id, email },
    dataCities: userShipping.cities,
    dataProvinces: userShipping.provinces,
    country,
    user,
    dataShipping: user.detail.user_shipping,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getList: (query) => dispatch(getConsignmentList(query)),
    deliverSneaker: (id, payload) => dispatch(doDeliverSneakerConsignment(id, payload)),
    getCountries: (query) => dispatch(getCountryList(query)),
    getProvinces: () => dispatch(doFetchProvinces()),
    getCities: (payload) => dispatch(doFetchCities(payload)),
    saveAddress: (shippingId, payload) => dispatch(saveUserAddress(shippingId, payload)),
    updateAddress: (userId, shippingId, payload) => dispatch(updateUserAddress(userId, shippingId, payload)),
    getUserAddress: (userId) => dispatch(getUserShippingList(userId)),
  }
};
const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(privateView(PreDelivering, ['supervisor', 'sale_supervisor']));